import moment, { Moment } from '@e3dc-react/shell/Libs/moment'

export interface GetEarliestFromDateReturnTypes {
  earliestFromDate: Moment
  shouldUseIncludeFirst: boolean
}

/**
 * Clamps the selected from date to the earliest date data is available for.
 */
export const getEarliestFromDate = (from: Moment, systemChartMinFromDate?: string): GetEarliestFromDateReturnTypes => {
  const isSelectedFromBeforeSyncedMin = !!systemChartMinFromDate && from.isBefore(moment(systemChartMinFromDate))
  const earliestFromDate = isSelectedFromBeforeSyncedMin ? moment(systemChartMinFromDate) : from

  const earliestFromDateFormattedToDayStart = earliestFromDate.clone().startOf('day')

  return { earliestFromDate: earliestFromDateFormattedToDayStart, shouldUseIncludeFirst: isSelectedFromBeforeSyncedMin }
}
